import React, { FC, ReactNode, useEffect, useState } from 'react';
import { GetProp, Image, message, Space, Upload, UploadFile, UploadProps } from 'antd';
import { uploadImageInConsole } from '@/services/ConsoleRequest';
import { RcFile } from 'antd/es/upload/index';
import { useParams } from 'umi';
import { InboxOutlined } from '@ant-design/icons';
import ImgCrop from '@/components/antd-img-crop/ImgCrop';

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

const getBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const ImageModuleUpload: FC<{
  value?: string;
  uploadButton?: ReactNode;
  url?: string;
  onChange?: (url?: string) => void;
  help?: ReactNode;
  maxSize?: number;
  imageCrop?: { width: number; height: number };
  className?: string;
  uploadButtonSize?: { width: number; height: number };
}> = ({
  uploadButtonSize,
  className,
  maxSize = 2,
  imageCrop,
  value,
  onChange,
  url,
  uploadButton,
  help,
}) => {
  const { id: recruitPageId } = useParams<{ id: string }>();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange: UploadProps['onChange'] = ({ file, fileList: newFileList }) => {
    //console.log('newFileList是');
    //console.log(newFileList);
    //console.log(file);
    //setFileList(newFileList);
    //if (newFileList.length === 0) {
    //  onChange(undefined);
    //}
  };

  const defaultUploadButton = (
    <div className="ant-upload-drag-container">
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">点击或拖拽文件到此处上传</p>
      <p className="ant-upload-hint">支持上传文件大小不超过2MB的.png\.jpg格式文件</p>
      <p className="ant-upload-hint">图片宽度为720px，高度不限</p>
    </div>
  );
  const uploadProps: UploadProps = {
    name: 'file',
    maxCount: 1,
    accept: '.png,.jpg',
    listType: 'picture-card',
    fileList,
    onPreview: handlePreview,
    onChange: handleChange,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      onChange?.(undefined);
    },
    beforeUpload: (file, fileList) => {
      console.log('beforeUpload');
      console.log(file);
      const isLt2MB = file.size / 1024 / 1024 <= maxSize;
      if (!isLt2MB) {
        const tips = maxSize > 1 ? `${maxSize}MB` : `${maxSize * 1000}KB`;
        message.error(`文件大小最大为${tips}`);
        setFileList([]);
        return false;
      }
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        message.error('只允许上传.png和.jpg格式文件');
        setFileList([]);
        return false;
      }
      return true;
    },
    customRequest: async (options) => {
      const { file } = options;
      const uploadRes = await uploadImageInConsole(
        file as RcFile,
        `/myfr/camp/recruitPage/${recruitPageId}`,
      );
      onChange?.(uploadRes.data);
      options.onSuccess?.({
        success: true,
        data: {
          url: uploadRes.data,
        },
      });
      console.log('uploadRes');
      console.log(uploadRes);
      setFileList([
        {
          uid: String(Date.now()),
          name: 'image.png',
          status: 'done',
          url: uploadRes.data,
        },
      ]);
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };
  useEffect(() => {
    if (url) {
      setFileList([
        {
          uid: String(Date.now()),
          name: 'image.png',
          status: 'done',
          url,
        },
      ]);
    }
  }, [url]);
  useEffect(() => {
    if (value) {
      setFileList([
        {
          uid: String(Date.now()),
          name: 'image.png',
          status: 'done',
          url: value,
        },
      ]);
    } else {
      setFileList([]);
    }
  }, [value]);
  const uploadButtonCom = uploadButton || defaultUploadButton;
  const uploadCom = <Upload {...uploadProps}>{fileList.length < 1 && uploadButtonCom}</Upload>;
  return (
    <>
      <Space align="start" className={className}>
        {imageCrop ? (
          <ImgCrop
            modalWidth={900}
            beforeCrop={uploadProps.beforeUpload}
            aspect={imageCrop.width / imageCrop.height}
            cropSize={{ width: imageCrop.width, height: imageCrop.height }}
          >
            {uploadCom}
          </ImgCrop>
        ) : (
          uploadCom
        )}
        {help}
      </Space>
      {previewImage && (
        <Image
          wrapperStyle={{ display: 'none' }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(''),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};
export default ImageModuleUpload;
